"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

var _auth = require("../utils/auth");

var _store = require("../store"); // import app components


var PrivateRoute = function PrivateRoute(props) {
  var Component = props.component,
      location = props.location,
      rest = (0, _objectWithoutProperties2.default)(props, ["component", "location"]);

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 1),
      config = _ref2[0].config;

  var loggedIn = (0, _auth.isLoggedIn)(config);
  var previewID = (0, _auth.isPreview)();
  (0, _react.useEffect)(function () {
    var location = props.location;

    if (!loggedIn && !previewID && location.pathname !== "/") {
      (0, _router.navigate)('/');
    }
  }, [loggedIn, previewID]);
  return loggedIn || previewID ? /*#__PURE__*/_react.default.createElement(Component, rest) : null;
};

var _default = PrivateRoute;
exports.default = _default;